/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rich_Wild_Wren_AskInputs */

const en_rich_wild_wren_ask = /** @type {(inputs: Rich_Wild_Wren_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments disabled`)
};

const de_rich_wild_wren_ask = /** @type {(inputs: Rich_Wild_Wren_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare deaktiviert`)
};

/**
* | output |
* | --- |
* | "Comments disabled" |
*
* @param {Rich_Wild_Wren_AskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_wild_wren_ask = /** @type {((inputs?: Rich_Wild_Wren_AskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Wild_Wren_AskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_wild_wren_ask(inputs)
	return de_rich_wild_wren_ask(inputs)
});